import { render, staticRenderFns } from "./sixSwitch.vue?vue&type=template&id=04c97c8c&scoped=true&"
import script from "./sixSwitch.vue?vue&type=script&lang=js&"
export * from "./sixSwitch.vue?vue&type=script&lang=js&"
import style0 from "./sixSwitch.vue?vue&type=style&index=0&id=04c97c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c97c8c",
  null
  
)

export default component.exports